module.exports = __webpack_public_path__ + "static/marketplace-website-plp-3a7d57c355d6847a1360c29533912349.png";